import './Section3Component.css'
import mujer from './images/mujer.png'
import pareja from './images/pareja.png'
import alcancia from './images/alcancia.png'
import donar from './images/donar.png'
import money_check from './images/money_check.png'
import credit_card from './images/credit_card.png'



export const Section3Component = () => {

    return (
        <div className="unidos_padding px-2 px-lg-0" id='unidos'>
            <div className="container_2">
                <div className="row m-0 p-0 text-center text-lg-start">
                    <div className="col-12 col-lg-6 m-0 p-0 unidos">
                        <h2 className="rubik_medium mb-0"><span className="blue_cl">Continuamos unidos</span> 
                            <br /> contigo a través de 
                            <br /> 
                            tus Giros
                        </h2>
                        <p className='my-4 lato_regular'>Cobra o Envía tus 
                            <span className='lato_bold'> Giros Internacionales Western Union </span> 
                            <span>a </span>
                            <br className='d-none d-lg-block'/>
                            través de nuestro portal, canales no presenciales, oficinas <br className='d-none d-lg-block'/>
                             a nivel nacional.
                        </p>
                    </div>
                    
                    <div className="col-12 col-lg-6 m-0 px-2 px-lg-0">
                        <img src={mujer} alt="Mujer" className='img-fluid'/>
                    </div>

                    <div className="unidos_gap"></div>

                    <div className="col-12 col-lg-6 m-0 px-2 px-lg-0">
                        <img src={pareja} alt="Pareja"  className='img-fluid'/>
                    </div>

                    <div className="col-12 col-lg-6 m-0 pt-4 pt-lg-0 unidos ps-lg-5">
                        <h2 className="rubik_medium"><span className='blue_cl'>Unidos contigo </span> 
                        para que Ahorres por tus sueños</h2>
                        <div className="d-flex flex-column gap-3 pt-3 pt-lg-0 lato_regular ps-0 ps-lg-3">
                            <div className='d-flex align-items-center gap-2'>
                                <div>
                                    <img src={alcancia} alt="Alcancia" />
                                </div>
                                <p className='m-0'>Cuenta de Ahorros</p>
                            </div>

                            

                            <div className='d-flex align-items-center gap-2'>
                                <div>
                                    <img src={credit_card} alt="Alcancia" />
                                </div>
                                <p className='m-0'>Tarjeta de Débito</p>
                            </div>

                            <div className='d-flex align-items-center gap-2'>
                                <div>
                                    <img src={money_check} alt="Alcancia" />
                                </div>
                                <p className='m-0'>CDT</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}